import { HkMark } from "@/components/BrandArt";

export function Brand({ size = "md", withText = true, tone = "dark" }) {
  const dims = size === "lg" ? "w-16 h-16" : size === "sm" ? "w-9 h-9" : "w-12 h-12";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <HkMark title={withText ? undefined : "HardKnockLegal"} className={`${dims} shrink-0`} />
      {withText && <div className="leading-none">
        <div className={`font-serif-display font-semibold tracking-tight ${size === "lg" ? "text-3xl" : "text-xl"}`}
          style={{ color: tone === "light" ? "#14243B" : "#F8F5EE" }}>HardKnockLegal</div>
        <div className="mt-1" style={{ color: "#C5A15A", fontSize: size === "sm" ? "8px" : "10px", letterSpacing: "0.2em", textTransform: "uppercase" }}>Legal Intelligence</div>
      </div>}
    </div>
  );
}
